import {BasePage} from '../utils/base';
import {Pages} from '..';
import {getMonkey} from '../utils/monkeys';
import '../css/passcode.scss';

export class PasscodePage extends BasePage {
  view: HTMLElement;
  codeInput: HTMLInputElement;
  iconEdit: SVGElement;

  monkeyIdle;
  monkeyTrack;

  disabled: boolean = false;

  prevPassCode: string = '';
  passcode: string = '';
  direction: boolean = true;

  constructor(openPage: Function) {
    super();

    let viewTemplate = this.templates.querySelector('.passcode') as HTMLElement;
    this.setPage(viewTemplate.cloneNode(true) as HTMLElement);

    this.view = this.app.querySelector('.passcode') as HTMLElement;

    let logo = this.view.querySelector('.logo') as HTMLElement;

    this.monkeyIdle = getMonkey(3).cloneNode(true);
    this.monkeyIdle.setAttribute('autoplay', 'true');
    this.monkeyIdle.setAttribute('loop', 'true');

    logo.appendChild(this.monkeyIdle);

    this.monkeyTrack = getMonkey(5).cloneNode(true);
    this.monkeyTrack.style.display = 'none';

    this.monkeyTrack.setAttribute('autoplay', 'true');
    this.monkeyTrack.setAttribute('loop', 'true');
    this.monkeyTrack.pause();

    this.monkeyTrack.addEventListener('frame', event => {
      if (
        this.passcode &&
        ((event.detail.seeker > (100 / 15) * (this.passcode.length + 1) && this.direction) ||
          (event.detail.seeker < (100 / 15) * this.passcode.length && !this.direction))
      ) {
        this.monkeyTrack.pause();
      } else {
        this.monkeyTrack.play();
      }
    });

    logo.appendChild(this.monkeyTrack);

    this.codeInput = this.view.querySelector('input') as HTMLInputElement;

    this.codeInput.addEventListener('keydown', this.codeKeyDown);
    this.codeInput.addEventListener('keyup', this.codeChange);

    this.iconEdit = this.view.querySelector('.icon') as SVGElement;
    this.iconEdit.addEventListener('click', () => {
      openPage(Pages.LOGIN);
    });

    let phoneNumber = this.view.querySelector('.title span') as HTMLElement;
    phoneNumber.innerHTML = `${this.storeHelper.store.phonePrefix} ${this.storeHelper.store.phoneNumber}`;

    requestAnimationFrame(() => {
      this.codeInput.focus();
    });
  }

  codeKeyDown = (event: KeyboardEvent) => {
    if (this.disabled) {
      event.preventDefault();
    }
  };

  codeChange = () => {
    if (this.disabled) {
      return;
    }

    this.prevPassCode = this.passcode;
    this.passcode = this.codeInput.value.replace(/[^0-9]/g, '').substr(0, 5);
    if (this.passcode.length === 5) {
      this.disabled = true;

      this.codeInput.classList.remove('wrong');
      this.codeInput.classList.add('disabled');

      this.apiHelper.setPasscode(this.passcode).catch(() => {
        this.codeInput.classList.add('wrong');

        this.disabled = false;
        this.codeInput.classList.remove('disabled');
      });
    }

    if (this.passcode) {
      this.monkeyIdle.style.display = 'none';
      this.monkeyTrack.style.display = 'block';

      if (!this.prevPassCode) {
        this.monkeyTrack.seek('0%');
      }
      if (this.prevPassCode.length < this.passcode.length) {
        this.direction = true;
        this.monkeyTrack.setDirection(1);
      } else {
        this.direction = false;
        this.monkeyTrack.setDirection(-1);
      }

      this.monkeyTrack.play();

      this.codeInput.classList.add('value');
    } else {
      this.monkeyTrack.style.display = 'none';
      this.monkeyIdle.style.display = 'block';

      if (this.prevPassCode) {
        this.monkeyIdle.seek('0%');
      }
      this.monkeyTrack.pause();

      this.codeInput.classList.remove('wrong');
      this.codeInput.classList.remove('value');
    }

    this.codeInput.value = this.passcode;
  };
}
